export const techstackImagesData = [
  {
    id: 1,
    src: "/images/react.svg",
    alt: "react",
    bgColor: "#5bf5ff",
  },
  {
    id: 2,
    src: "/images/tailwindcss.svg",
    alt: "tailwindcss",
    bgColor: "#15D5BF",
  },
  {
    id: 3,
    src: "/images/supabase.svg",
    alt: "supabase",
    bgColor: "#40D995",
  },
  {
    id: 4,
    src: "/images/nextjs.svg",
    alt: "nextjs",
    bgColor: "#FFFFFF",
  },
  {
    id: 5,
    src: "/images/typescript.svg",
    alt: "typescript",
    bgColor: "#327ED0",
  },
  {
    id: 6,
    src: "/images/nodejs.svg",
    alt: "nodejs",
    bgColor: "#65B84A",
  },
  {
    id: 7,
    src: "/images/jest.svg",
    alt: "jest",
    bgColor: "#A04660",
  },
  {
    id: 8,
    src: "/images/redux.svg",
    alt: "redux",
    bgColor: "#7D4EC6",
  },
];
